/**
 * Telling "this does not exist" apart from "this did not load".
 *
 * The experience builder reported every load failure as `experience.errors.notFound` — a network
 * blip, a 500, an expired session and a genuinely deleted experience all printed "Experience not
 * found". That message is a claim about the data, so a teacher reading it concludes their work is
 * gone and goes looking for it, when nothing was wrong with it at all.
 *
 * Only a 404 is evidence about the data. Everything else is evidence about the request.
 */
import { ApiError } from './api';

/** The `errors.*` key to show, relative to whichever page is asking. */
export type LoadFailure = 'notFound' | 'couldNotLoad';

export function classifyLoadFailure(error: unknown): LoadFailure {
  return error instanceof ApiError && error.status === 404 ? 'notFound' : 'couldNotLoad';
}
